export default function Privacy() {
  return (
    <main className="main">
      <div className="page-hero fi" style={{ paddingBottom: 24 }}>
        <div className="hero-tag">Privacybeleid</div>
        <h1>Jouw <em>privacy</em> bij Givn</h1>
        <p>Hoe we omgaan met jouw gegevens — kort en duidelijk.</p>
      </div>

      <div style={{ width: "100%", maxWidth: 680, marginBottom: 48 }}>
        {[
          {
            title: "Wat we opslaan",
            body: "Alleen je e-mailadres, als je dat zelf invult om suggesties te ontvangen. Profielgegevens (naam, interesses, datum) worden niet opgeslagen — ze worden alleen gebruikt om de suggesties te genereren."
          },
          {
            title: "Waarvoor we je e-mail gebruiken",
            body: "Om je de cadeausuggesties toe te sturen, en om je te kunnen herinneren aan het event. We sturen geen reclame of nieuwsbrieven zonder toestemming."
          },
          {
            title: "Delen met derden",
            body: "We delen je e-mailadres nooit met derden. We gebruiken Brevo als e-mailprovider — zij verwerken je gegevens conform de AVG."
          },
          {
            title: "Affiliate links",
            body: "Productlinks in onze mails en in de app zijn affiliate links. Als je iets bestelt via onze link, ontvangen wij een kleine commissie van de webshop — zonder dat jij meer betaalt."
          },
          {
            title: "Jouw rechten",
            body: "Je kunt op elk moment vragen om inzage, correctie of verwijdering van je gegevens. Mail naar hallo@givn.to met je verzoek."
          },
          {
            title: "Contact",
            body: "Vragen over privacy? Mail hallo@givn.to. We reageren altijd binnen 5 werkdagen."
          },
        ].map((s, i) => (
          <div key={i} className="faq-item fi" style={{ animationDelay: `${i * 0.07}s` }}>
            <div className="faq-q">{s.title}</div>
            <div className="faq-a">{s.body}</div>
          </div>
        ))}
      </div>
    </main>
  );
}
